import { render, staticRenderFns } from "./aspect-component.vue?vue&type=template&id=0e91a995&scoped=true&"
import script from "./aspect-component.vue?vue&type=script&lang=ts&"
export * from "./aspect-component.vue?vue&type=script&lang=ts&"
import style0 from "./aspect-component.vue?vue&type=style&index=0&id=0e91a995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e91a995",
  null
  
)

export default component.exports